/**
 * Scroll-triggered animations — assets/animations.js
 * ─────────────────────────────────────────────────────────────
 * Uses IntersectionObserver API only — no scroll event listeners.
 * CSS handles opacity + translateY transitions (GPU-accelerated).
 * Animates each element exactly once (unobserves after trigger).
 * prefers-reduced-motion is handled entirely in CSS.
 *
 * Requires: <html class="js-ready"> added by inline script in <head>.
 * Elements: .animate-on-scroll with optional style="--anim-delay: Xms"
 */
(function () {
  'use strict';

  /* ── Graceful fallback for browsers without IntersectionObserver ── */
  if (!('IntersectionObserver' in window)) {
    var all = document.querySelectorAll('.animate-on-scroll');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.add('is-visible');
    }
    return;
  }

  /* ── Intersection Observer ── */
  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          /* Unobserve immediately — animate once, then release the callback */
          observer.unobserve(entry.target);
        }
      }
    },
    {
      threshold: 0.08,            /* Trigger when 8% of the element is visible */
      rootMargin: '0px 0px -32px 0px'  /* Small negative bottom margin — fires just before fully visible */
    }
  );

  /* ── Observe all targets ── */
  var targets = document.querySelectorAll('.animate-on-scroll');
  for (var j = 0; j < targets.length; j++) {
    observer.observe(targets[j]);
  }

})();

/* ── Header scroll shadow ──
   Adds .is-scrolled to <body> when page scrolls > 10px.
   CSS uses this to add a subtle shadow to .header-section.
   passive:true — no preventDefault calls, improves scroll perf.
─────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  function onScroll() {
    document.body.classList.toggle('is-scrolled', window.scrollY > 10);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load in case page starts scrolled
})();
